module.exports = __webpack_public_path__ + "assets/img/Australian-Institute-of-Fitness-Website.ad5d208b.jpg";